import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticationGuard } from '@barthauer/basys/core/authentication';
import { ResourceEventMaterialMaterialExpenseComponent } from '../resources/resource-event-material-material-expense/resource-event-material-material-expense.component';
import { ResourceEventOtherOtherComponent } from '../resources/resource-event-other-other/resource-event-other-other.component';
import { ResourceEventPersonnelWorkingTimesComponent } from '../resources/resource-event-personnel-working-times/resource-event-personnel-working-times.component';
import { ResourceEventVehicleDowntimeComponent } from '../resources/resource-event-vehicle-downtime/resource-event-vehicle-downtime.component';
import { ResourceEventVehicleMileageComponent } from '../resources/resource-event-vehicle-mileage/resource-event-vehicle-mileage.component';
import { ResourceEventVehicleOperatingHoursComponent } from '../resources/resource-event-vehicle-operating-hours/resource-event-vehicle-operating-hours.component';
import { ResourceEventVehicleWaterFillingComponent } from '../resources/resource-event-vehicle-water-filling/resource-event-vehicle-water-filling.component';
import { ResourceListComponent } from '../resources/resource-list/resource-list.component';
import { AppService } from '../services/app.service';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { WorkDetailComponent } from './work-detail/work-detail.component';
import { WorkListComponent } from './work-list/work-list.component';

const worksRoutes: Routes = [
  {
    path: AppService.Route_WorkList,
    component: WorkListComponent,
    data: { animation: AppService.Route_WorkList, reuse: true, mainOutletName: 'mainOutlet' },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Works,
  },
  {
    path: AppService.Route_WorkDetail,
    component: WorkDetailComponent,
    data: { animation: AppService.Route_WorkDetail, mainOutletName: 'mainOutlet' },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Works,
    children: [
      {
        path: AppService.Route_ResourceList,
        component: ResourceListComponent,
        data: { reuse: false },
      },
      {
        path: AppService.Route_ResourceEventVehicleMileage,
        component: ResourceEventVehicleMileageComponent,
      },
      {
        path: AppService.Route_ResourceEventVehicleOperatingHours,
        component: ResourceEventVehicleOperatingHoursComponent,
      },
      {
        path: AppService.Route_ResourceEventVehicleDowntime,
        component: ResourceEventVehicleDowntimeComponent,
      },
      {
        path: AppService.Route_ResourceEventVehicleWaterFilling,
        component: ResourceEventVehicleWaterFillingComponent,
      },
      {
        path: AppService.Route_ResourceEventPersonnelWorkingTimes,
        component: ResourceEventPersonnelWorkingTimesComponent,
      },
      {
        path: AppService.Route_ResourceEventMaterialMaterialExpense,
        component: ResourceEventMaterialMaterialExpenseComponent,
      },
      {
        path: AppService.Route_ResourceEventOtherOther,
        component: ResourceEventOtherOtherComponent,
      },
    ],
  },
  {
    path: AppService.Route_TaskDetail,
    component: TaskDetailComponent,
    data: { animation: AppService.Route_TaskDetail, mainOutletName: 'mainOutlet' },
    canActivate: [AuthenticationGuard],
    outlet: AppService.RouterOutlet_Works,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(worksRoutes)],
  exports: [RouterModule],
})
export class WorksRoutingModule {}
